export default "__VITE_PUBLIC_ASSET__3ef300e1__"